import React from 'react';
import { QueryProvider, WebSocketProvider, ErrorBoundaryProvider, HeroUIProvider, AuthProvider } from './providers';
import { AppRouter } from './routing';

export const App: React.FC = () => {
  return (
    <ErrorBoundaryProvider>
      <QueryProvider>
        <AuthProvider>
          <WebSocketProvider>
            <HeroUIProvider>
              <AppRouter />
            </HeroUIProvider>
          </WebSocketProvider>
        </AuthProvider>
      </QueryProvider>
    </ErrorBoundaryProvider>
  );
};